import { render, staticRenderFns } from "./alertConfigs.vue?vue&type=template&id=ebce226c&"
import script from "./alertConfigs.vue?vue&type=script&lang=js&"
export * from "./alertConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports